const environmentUrl = (function(env) {
  switch (env) {
    case 'Development':
      return 'https://jmibackend-dev.azurewebsites.net/api/v1';
    case 'Staging':
      return 'https://jmibackend-staging.azurewebsites.net/api/v1';
    case 'Production':
      return 'https://backend.blueskyvue.com/api/v1';
    case 'production':
      return 'https://backend.blueskyvue.com/api/v1';
    case 'local':
      return 'http://localhost:63138/api/v1';
    case 'ngrok':
      return 'https://ace-shepherd-plainly.ngrok-free.app/api/v1';
    // return 'https://good-magical-kiwi.ngrok-free.app/api/v1';
    default:
      return 'http://localhost:63138/api/v1';
  }
})(process.env.REACT_APP_BACKEND_ENV);

const getToken = () => localStorage.getItem('token');

const getHeaders = (optionalHeaders = {}) => {
  const token = getToken();
  let defaultHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'ngrok-skip-browser-warning': '69420',
  };

  if (token) {
    defaultHeaders.Authorization = `Bearer ${token}`;
  }

  const headers = Object.assign({}, defaultHeaders, optionalHeaders);
  return headers;
};

export const DEFAULT_API_CONFIG = {
  url: environmentUrl,
  timeout: 10000,
  getHeaders,
  getToken,
};
